const ReadOnlyBadge = () => (
  <span className="ml-2 inline-flex items-center rounded bg-muted px-1.5 py-0.5 text-[11px] leading-none text-muted-foreground">
    Read-only
  </span>
);

export default ReadOnlyBadge;
